import moment from "moment-timezone";

const EASTERN_TIMEZONE = "America/New_York";

export function formatDate(dateString, withTime = false) {
  if (!dateString) {
    return "Pending";
  }

  const momentDate = moment.utc(dateString).tz(EASTERN_TIMEZONE);

  if (!momentDate.isValid()) {
    return "Pending";
  }

  return momentDate.format(withTime ? "MM/DD/YYYY, h:mm A" : "MM/DD/YYYY");
}
